import { Role } from '@models';

export interface RolesResult {
  roles: Role[];
}
